module.exports = __webpack_public_path__ + "static/shortcut_key1-6cc009547d635a91a866739869c7b7c3.jpg";